export const validateEmail = string => {
  const regex =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  let errorMessage = 'Please enter a valid email.';
  if (!string.includes('@')) {
    errorMessage = "Please include an '@' in the email address.";
  }

  return regex.test(string || '') ? '' : errorMessage;
};

// Implements the django.contrib.auth.password_validation.MinimumLengthValidator class
const validateMinimumLength = password => {
  return password.length < 12
    ? 'This password is too short. It must contain at least 12 characters'
    : '';
};

// Implements the password_validators.AlphaNumericSpecialPasswordValidator class
const validatePasswordRegEx = password => {
  const specialCharacters = new RegExp('[#?!@$%^&*-]');
  const hasAlphabetic = new RegExp('[a-zA-Z]');
  const hasNumeric = new RegExp('[0-9]');

  if (!hasAlphabetic.test(password)) {
    return 'This password must contain at least one alphabetic character!';
  }
  if (!specialCharacters.test(password)) {
    return 'This password must contain at least one of the following special characters: #?!@$%^&*-';
  }
  if (!hasNumeric.test(password)) {
    return 'This password must contain at least one numeric character!';
  }

  return '';
};

// Implements the password_validators.BannedTokensValidator class
const validateBannedTokens = (email = '', password = '') => {
  const errrorString = 'Your password cannot contain this word:';
  const bannedTokens = ['metlife', 'password'];
  if (email) {
    bannedTokens.push(email.toLowerCase());
  }
  const bannedToken = bannedTokens
    .map(token => password.match(token)?.[0] || null)
    .find(token => token !== null);
  if (bannedToken) {
    return `${errrorString} '${bannedToken}'`;
  }

  return '';
};

// Implements the django.contrib.auth.password_validation.exceeds_maximum_length_ratio method
const exceedsMaxLengthRatio = (password, maxSimilarity, value) => {
  const passwordLength = password.length;
  const lengthBoundSimilarity = (maxSimilarity / 2) * passwordLength;
  const valueLength = value.length;
  return passwordLength >= 10 * valueLength && valueLength < lengthBoundSimilarity;
};

// Implements the python difflib.SequenceMatcher().quick_ratio method
const sequenceMatcher = (a, b) => {
  const bigString = a.length > b.length ? a : b;
  const smallString = a.length <= b.length ? a : b;

  let diffs = bigString.length - smallString.length;
  for (let index = 0; index < smallString.length; index++) {
    if (smallString[index] !== bigString[index]) {
      diffs += 1;
    }
  }
  return 1 - diffs / (bigString.length + smallString.length);
};

// Implements the django.contrib.auth.password_validation.UserAttributeSimilarityValidator class
// https://github.com/django/django/blob/main/django/contrib/auth/password_validation.py
const validateForSimiliarAttributes = (email = '', password = '') => {
  if (email.length === 0 || password.length === 0) {
    return '';
  }

  const maxSimilarity = 0.7; // 70%
  if (exceedsMaxLengthRatio(password, maxSimilarity, email)) {
    return '';
  }

  const lowercaseEmail = email.toLowerCase();
  const parts = lowercaseEmail.split(/\W+/).concat(lowercaseEmail);
  for (let index = 0; index < parts.length; index++) {
    if (sequenceMatcher(password, parts[index]) >= maxSimilarity) {
      return 'This password is too similiar to your email address';
    }
  }

  return '';
};

export const validatePassword = (email = '', password = '') => {
  if (password.length === 0) {
    return '';
  }
  const alphaNumericValidation = validatePasswordRegEx(password);
  const bannedTokenValidation = validateBannedTokens(email, password);
  const minimumLengthValidation = validateMinimumLength(password);
  const similiarAttributesValidation = validateForSimiliarAttributes(email, password);
  return (
    alphaNumericValidation ||
    bannedTokenValidation ||
    minimumLengthValidation ||
    similiarAttributesValidation
  );
};
